@let day = result();
@if (showSummary()) {
  <div class="summary">
    <p-tag [value]="day.status" [severity]="statusSeverity()"></p-tag>
    <div class="stat">
      <span class="label">Final score</span>
      <span class="value">{{ day.finalScore | number: '1.3-3' }}</span>
    </div>
    <div class="stat">
      <span class="label">Band</span>
      <span class="value">{{ band() }}</span>
    </div>
    <div class="stat">
      <span class="label">Preliminary</span>
      <span class="value">{{ day.preliminaryScore | number: '1.3-3' }}</span>
    </div>
    <div class="stat">
      <span class="label">Energy balance</span>
      <span class="value">
        {{ day.energyBalance | number: '1.2-3' }} × {{ day.energyMultiplier | number: '1.1-2' }}
      </span>
    </div>
    <div class="stat">
      <span class="label">Plan</span>
      <span class="value">{{ day.planType }} {{ day.planEffectiveDate ?? '' }}</span>
    </div>
    <div class="stat">
      <span class="label">Algorithm</span>
      <span class="value">v{{ day.algorithmVersion }}</span>
    </div>
    @if (day.scoredAtUtc; as scoredAtUtc) {
      <div class="stat">
        <span class="label">Scored at</span>
        <span class="value">{{ utcStamp(scoredAtUtc) }}</span>
      </div>
    }
  </div>
}

@if (day.categories.length > 0) {
  <p-table [value]="day.categories" [tableStyle]="{ 'min-width': '40rem' }">
    <ng-template #header>
      <tr>
        <th>Category</th>
        <th>CWAS</th>
        <th>CPF</th>
        <th>Weighted</th>
        <th>Band ±</th>
        <th>Nutrients</th>
      </tr>
    </ng-template>
    <ng-template #body let-category>
      <tr>
        <td>{{ scoringCategoryName(category.category) }}</td>
        <td>{{ category.score | number: '1.3-3' }}</td>
        <td>{{ category.priorityFactor | number: '1.0-2' }}</td>
        <td>{{ category.weightedScore | number: '1.3-3' }}</td>
        <td>{{ category.standardDeviation | number: '1.3-3' }}</td>
        <td>{{ category.nutrientCount }}</td>
      </tr>
    </ng-template>
  </p-table>
}

@if (day.nutrients.length > 0) {
  <p-table scrollHeight="20rem" [value]="day.nutrients" [scrollable]="true" [tableStyle]="{ 'min-width': '56rem' }">
    <ng-template #header>
      <tr>
        <th>Nutrient</th>
        <th>Category</th>
        <th>Score</th>
        <th>Quantity</th>
        <th>DMIN</th>
        <th>DO</th>
        <th>DMAX</th>
        <th>NIF</th>
        <th>Weighted</th>
      </tr>
    </ng-template>
    <ng-template #body let-nutrient>
      <tr>
        <td class="mono">{{ nutrient.nutrientId }}</td>
        <td>{{ scoringCategoryName(nutrient.category) }}</td>
        <td>{{ nutrient.score | number: '1.3-3' }}</td>
        <td>{{ nutrient.quantity | number: '1.0-4' }}</td>
        <td>{{ nutrient.dailyMin | number: '1.0-4' }}</td>
        <td>{{ nutrient.dailyOptimal | number: '1.0-4' }}</td>
        <td>{{ nutrient.dailyMax | number: '1.0-4' }}</td>
        <td>{{ nutrient.importanceFactor | number: '1.1-2' }}</td>
        <td>{{ nutrient.weightedScore | number: '1.3-3' }}</td>
      </tr>
    </ng-template>
  </p-table>
}

@if (collapsedRampNutrients(); as nutrientIds) {
  <p-message severity="warn" [text]="'Inverted overage ramp collapsed for: ' + nutrientIds"></p-message>
}
